import { useAnalyticsLayout } from './useAnalyticsLayout';

export { useAnalyticsLayout };
